/**
 * Created by boris on 3/31/17.
 */
import React from 'react'
import Paper from '@material-ui/core/Paper'
import UserPageInfo from '../UserPageInfo'
import ContentLoading from '../ContentLoading'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import {
  loadFollowingsRequestsList,
  initialFollowingsRequestsList,
  loadNextFollowingsRequestsList,
  setFollowingRequestDelete,
} from '../../actions/FollowingsRequestsActions'
import {
  getShowUser,
  showUserInitial,
  setShowUser,
} from '../../actions/ShowUserActions'
import { unfollowUser } from '../../actions/FollowUnfollowActions'
import Typography from '@material-ui/core/Typography'

import UsersList from '../UsersList'
import { Box } from '@material-ui/core'

class FollowingsRequestsPage extends React.Component {
  componentWillMount() {
    const { loadFollowingsRequestsList, getShowUser, auth } = this.props
    const { user, isAuthenticated } = auth
    const { user_id } = this.props.params
    if (user_id !== user.id) getShowUser(user_id, !isAuthenticated)
    loadFollowingsRequestsList(user_id)
  }

  componentWillUnmount() {
    this.props.showUserInitial()
    this.props.initialFollowingsRequestsList()
  }

  loadNextData() {
    const { followings, loadNextFollowingsRequestsList } = this.props
    loadNextFollowingsRequestsList(followings.pagination.next_url)
  }

  cancelRequest(user_id) {
    const {
      auth,
      unfollowUser,
      setFollowingRequestDelete,
      setShowUser,
    } = this.props
    unfollowUser(auth.user.id, user_id).then(data => {
      setShowUser(data)
      setFollowingRequestDelete(user_id)
    })
  }

  render() {
    const { followings, auth, showUser } = this.props
    let { user } = auth
    const { user_id } = this.props.params
    let { users, pagination, isLoading } = followings
    users = [...users.values()]
    let userPage = (
      <UserPageInfo
        followingsLink={`/users/${user.id}/followings`}
        followersLink={`/users/${user.id}/followers`}
        buttonTitle={'MY NUUZ'}
        handleButtonClick={() => browserHistory.push(`/users/${user.id}`)}
        linkTo={`/users/${user.id}`}
        user={user}
      />
    )

    let showUserPage = null
    if (user_id !== user.id && !showUser.isLoading) {
      showUserPage = (
        <UserPageInfo
          followingsLink={`/users/${showUser.user.id}/followings`}
          followersLink={`/users/${showUser.user.id}/followers`}
          buttonTitle={'MY NUUZ'}
          handleButtonClick={() =>
            browserHistory.push(`/users/${showUser.user.id}`)
          }
          linkTo={`/users/${showUser.user.id}`}
          user={showUser.user}
        />
      )
    }

    return (
      <Box className="page-content page-content-full-height">
        <Paper elevation={5} className="user-page">
          {user_id === user.id && userPage}
          {user_id !== user.id && !isLoading && showUserPage}
          <div className="blacklist-content">
            <div className="follows-list-top">
              <Typography className="subheader-20">My requests</Typography>
            </div>
            {isLoading ? (
              <ContentLoading small={true} />
            ) : (
              <div className="blacklist-container">
                {users.length === 0 ? (
                  <Typography className="no-stories">
                    No users to display
                  </Typography>
                ) : (
                  <UsersList
                    menuItems={[
                      {
                        handler: this.cancelRequest.bind(this),
                        label:   'Cancel request',
                      },
                    ]}
                    users={users}
                    loadNextData={this.loadNextData.bind(this)}
                    pagination={pagination}
                    subheader="My requests"
                  />
                )}
              </div>
            )}
          </div>
        </Paper>
      </Box>
    )
  }
}

function mapStateToProps(state) {
  return {
    showUser:   state.showUser,
    auth:       state.auth,
    followings: state.followingsRequests,
  }
}

export default connect(mapStateToProps, {
  loadFollowingsRequestsList,
  initialFollowingsRequestsList,
  loadNextFollowingsRequestsList,
  getShowUser,
  showUserInitial,
  unfollowUser,
  setShowUser,
  setFollowingRequestDelete,
})(FollowingsRequestsPage)
